/**
 * @uno/feature-flags
 *
 * Simple feature flags implementation for the unosquare-os monorepo.
 * Uses environment variables to configure flags for different environments.
 *
 * @example
 * // In your shell app
 * import { FeatureFlagsProvider } from '@uno/feature-flags';
 *
 * function App() {
 *   return (
 *     <FeatureFlagsProvider>
 *       <YourApp />
 *     </FeatureFlagsProvider>
 *   );
 * }
 *
 * @example
 * // In your components
 * import { useFeatureFlag, FeatureGate } from '@uno/feature-flags';
 *
 * function MyComponent() {
 *   const isNewDashboardEnabled = useFeatureFlag('enableNewDashboard');
 *
 *   return (
 *     <FeatureGate flag="enableBetaFeatures">
 *       <BetaFeature />
 *     </FeatureGate>
 *   );
 * }
 */
export { FeatureGate } from './components';
export { getEnvironment, isFeatureEnabled, loadFeatureFlags } from './config';
export { FeatureFlagsProvider, useFeatureFlag, useFeatureFlags, useFeatureFlags_Multiple } from './context';
